








import { defineComponent, PropType } from '@vue/composition-api';

import { useTopicBookmarkDropdownMenuToggleButton } from '@/modules/teamplan/organisms/ProjectBookmarkDropdownMenu/TopicBookmarkDropdownMenuToggleButton';
import type { ProjectWithBookmarks } from '@/modules/teamplan/apis/useProjectsBookmarksListWithSWRV';

import DropdownMenuItemBase from '@/modules/teamplan/organisms/DropdownMenu/DropdownMenuItemBase.vue';

export default defineComponent({
  name: 'TopicBookmarkDropdownMenuToggleButton',
  components: {
    DropdownMenuItemBase,
  },
  props: {
    topicId: {
      type: Number,
      required: true,
    },
    project: {
      type: Object as PropType<ProjectWithBookmarks>,
      required: true,
    },
  },
  setup(props, { emit }) {
    return useTopicBookmarkDropdownMenuToggleButton(props, emit);
  },
});
